import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const questionQueries = [
  'waiverQuestions',
  'waiverQuestion',
];

/** Queries that embed or resolve pinned questions. */
const questionEmbeddedQueries = [
  ...questionQueries,
  'waiverTemplates',
  'waiverTemplate',
  'waiverPublishedTemplates',
  'waiverForms',
  'waiverForm',
];

const waiverQuestionMutations: UpdatesConfig['Mutation'] = {
  waiverQuestionCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(questionQueries, cache);
  },
  waiverQuestionUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(questionEmbeddedQueries, cache);
  },
  waiverQuestionStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery(questionEmbeddedQueries, cache);
  },
};

export default waiverQuestionMutations;
